import React, { useEffect } from 'react';
import { InputComponentProps, PropertyType } from './types';
import FIELD_TYPE_TO_COMPONENT from './fieldTypeToComponent';
import { useInputHelper } from 'framework/form';

type SkillInputConfigProps = {
  propertiesSource: string;
  propertiesShema: PropertyType[];
};

const PrerenderInputComponent = ({
  source,
  propertyDetails,
  InputComponent,
  isInit,
  renderNestedProperties,
}: InputComponentProps & { InputComponent: React.FC<InputComponentProps>; isInit: boolean }) => {
  const { initializeValue, getValue } = useInputHelper({
    source: `${source}.${propertyDetails.propertyName}`,
  });

  const currentValue = getValue();

  useEffect(() => {
    if (!currentValue && isInit) {
      initializeValue([
        {
          value: '',
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InputComponent source={source} propertyDetails={propertyDetails} renderNestedProperties={renderNestedProperties} />
  );
};

const SkillInputConfig = ({ propertiesSource, propertiesShema }: SkillInputConfigProps) => {
  const renderNestedProperties = (props: SkillInputConfigProps) => <SkillInputConfig {...props} />;

  return propertiesShema.map(item => {
    const fieldConfig = FIELD_TYPE_TO_COMPONENT[item.fieldType];
    if (!fieldConfig) {
      return null;
    }

    return (
      <PrerenderInputComponent
        key={`${propertiesSource}-${item.propertyName}`}
        InputComponent={fieldConfig.Component}
        source={propertiesSource}
        isInit={fieldConfig.isInit}
        propertyDetails={item}
        renderNestedProperties={renderNestedProperties}
      />
    );
  });
};

export default SkillInputConfig;
